import AbstractDeviceSetup from "../all/AbstractDeviceSetup";

class TizenDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }
}

export default TizenDeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/tizen/DeviceSetup.js